import { withStyles } from '@material-ui/core'
import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import withErrorCatcher from '../../../components/Common/withErrorCatcher'
import { useTranslation } from 'react-i18next'
import { CollapsibleDropdown } from './Dropdown'

const styles = theme => ({
    container: {
        position: 'relative',
        zIndex: 1,
        marginTop: '10vh',
        marginRight: 'auto',
        marginLeft: "auto",
        display: 'flex',
        flexDirection: 'column',
        width: 'fit-content',
        alignItems: 'center',
    },
    title: {
        color: "#18181B",
        fontFamily: "Rubik",
        fontSize: 24,
        fontStyle: "normal",
        fontWeight: 600,
        lineHeight: "32px"
    },
    subtitle: {
        color: "#6B6F7A",
        fontFamily: "Rubik",
        fontSize: 14,
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "20px"
    },
    btn: {
        cursor: 'pointer',
        display: "flex",
        marginTop: '3vh',
        background: '#6366F1',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: "space-between",
        padding: '6px 30px',
        borderRadius: 6,
        height: 20,
        marginBottom: '6vh',
        width: 'fit-content'
    },
    btnText: {
        color: "#fff",
        fontFamily: "Rubik",
        fontSize: 14,
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "20px"
    },
    disabledBtn: {
        pointerEvents: 'none',
        background: '#B7B8BD'
    },
    content: {
        marginTop: '6vh',
        display: 'flex',
        width: '42vw',
        padding: "var(--16, 16px) 16px",
        flexDirection: 'column',
        justifyContent: "center",
        alignItems: "flex-start",
        borderRadius: 8,
        background: "var(--bg-layer-on, #FFF)",
        boxShadow: "0px 1px 0px 0px rgba(255, 255, 255, 0.08) inset, 0px 0px 0px 1px rgba(255, 255, 255, 0.02) inset, 0px 1px 1px -0.5px var(--modul-shadow, rgba(107, 111, 122, 0.06)), 0px 3px 3px -1.5px var(--modul-shadow, rgba(107, 111, 122, 0.06)), 0px 6px 6px -3px var(--modul-shadow, rgba(107, 111, 122, 0.06)), 0px 12px 12px -6px var(--modul-shadow, rgba(107, 111, 122, 0.06)), 0px 24px 24px -12px var(--modul-shadow, rgba(107, 111, 122, 0.06))",
    },
    label: {
        marginBottom: 8,
        color: "#18181B",
        fontFamily: "Rubik",
        fontSize: 14,
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "20px"
    },
    moreOpts: {
        marginTop: 24,
        display: 'flex',
        columnGap: 8,
        width: '100%',
        justifyContent: 'space-between'
    },
    dropdownSelectorOption: {
        padding: '8px 16px',
        cursor: 'pointer',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        color: '#5C6886',
        height: '28px',
        boxSizing: 'border-box',
        borderRadius: '8px',
        '&:hover': {
          background: 'rgba(183, 184, 189, 0.2)',
        },
      },
    input: {
        color: '#21212d',
        width: '-webkit-fill-available',
        resize: 'none',
        padding: 0,
        outline: 0,
        fontSize: 14,
        fontStyle: 'normal',
        fontWeight: 400,
        fontFamily: "Rubik",
        lineHeight: "16px",
        paddingLeft: 8,
        paddingRight: 8,
        backgroundColor: "transparent",
        borderRadius: 8,
        border: '1px solid #B7B8BD33',
        height: 32,
        fontFeatureSettings: "'clig' off, 'liga' off",
        "&::placeholder": {
            color: '#B7B8BD',
        },
    }
})


const roleOpts = ['Owner', 'C-Level', 'Manager', 'Team Lead', 'Individual', 'Freelancer']
const langOpts = ['English', 'עברית', 'Español', 'Polski', 'Deutsch', 'Português', 'русский', 'Français', 'Українська']
const langOptsObj = [
        { value: "en-US", display: 'English' },
        { value: "he-IL", display: 'עברית' },
        { value: "es-AR", display: 'Español' },        
        { value: "pl", display: 'Polski' },
        { value: "de", display: 'Deutsch' },
        { value: "pt-BR", display: 'Português' },
        { value: "ru", display: 'русский' },
        { value: "fr", display: 'Français' },
        {value : 'uk-UA', display: 'Українська'},
    ]

const getValueByLabel = (val) => {
    return langOptsObj.find(x => x.display === val)?.value ?? 'en-US'
}
const getLabelByValue = (val) => {
    return langOptsObj.find(x => x.value === val)?.display ?? 'en-US'
}
const _Step1 = (props) => {
    const { 
        classes, 
        allowNext, 
        onNext, 
        setName, 
        name, 
        isThirdPartyLogin, 
        role, 
        setRole, 
        
        userLang, 
        setUserLang, 
} = props
    const [t] = useTranslation("admin")

    const onKeyDownHadnler = (event) => {
        if (event.key === 'Enter') {
            event.stopPropagation()
            onNext()
            return false
        }
        return true
    }

      
    const onChange = (event) => {
        const val = event.target.value

        setName(val)
    }


    return <div className={classes.container}>
        <div className={classes.title}>{t("You")}</div>
        <div className={classes.subtitle}>{t("We want to get to know you...")}</div>
        <div onClick={onNext} className={`${classes.btn} ${!allowNext ? classes.disabledBtn : ""}`}>
            <div className={classes.btnText}>{t("Next")}</div>
        </div>
        <div className={classes.content}>
            <div className={classes.label}>{t("Your Name?")}</div>
            <input disabled={false} className={classes.input} placeholder={t("Jone Doe")} type="text" value={name} onKeyDown={onKeyDownHadnler} onChange={onChange} />
            <div className={classes.moreOpts}>
                <div>
                    <CollapsibleDropdown
						label={`Your Role?`}
						placeholder={t("Pick role")}
						leftIcon={null}
						customStyles={{background: 'white'}}
						defaultValue={role}
						content={ 
						<>
							{roleOpts.map((option) => (
							<div
								key={option}
								className={`${classes.dropdownSelectorOption} ${option === role ? classes.selected : ''}`}
								onClick={() => setRole(option) }
							>
								<div className={classes.row}>
								<div className={classes.inputText}>{option}</div>
								</div>
							</div>
							))}
						</>
						}
				/>
                </div>
                <div>
                    <CollapsibleDropdown
						label={`Your Language?`}
						placeholder={t("Pick language")}
						leftIcon={null}
						customStyles={{background: 'white'}}
						defaultValue={getLabelByValue(userLang)}
						content={ 
						<>
							{langOpts.map((option) => (
							<div
								key={option}
								className={`${classes.dropdownSelectorOption} ${option === getLabelByValue(userLang) ? classes.selected : ''}`}
								onClick={() => setUserLang(getValueByLabel(option)) }
							>
								<div className={classes.row}>
								<div className={classes.inputText}>{option}</div>
								</div>
							</div>
							))}
						</>
						}
				/>
                </div>
                </div>
        </div>
    </div>
}

const mapStateToProps = (state, ownProps) => ({

})

const mapDispatchToProps = (dispatch) => ({ dispatch })


export const Step1 = compose(
    withStyles(styles, { withTheme: true }),   
    connect(mapStateToProps, mapDispatchToProps),
    withErrorCatcher("Failed loading user, Please Contact Tuqqi Support")
)(_Step1)